import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

let _cache = null;
const _subs = new Set();

export function useBranding() {
  const [b, setB] = useState(_cache);
  useEffect(() => {
    const sub = (v) => setB(v);
    _subs.add(sub);
    if (_cache) setB(_cache);
    else {
      axios.get(`${API}/settings/public`).then(({ data }) => {
        _cache = data; _subs.forEach((s) => s(data));
        if (data.favicon_url) {
          let link = document.querySelector("link[rel~='icon']");
          if (!link) { link = document.createElement("link"); link.rel = "icon"; document.head.appendChild(link); }
          link.href = data.favicon_url;
        }
      }).catch(() => {});
    }
    return () => _subs.delete(sub);
  }, []);
  return b || {};
}

// Tasteful logo with text wordmark fallback — never a broken image.
export default function Brand({ variant = "full", dark = false, className = "" }) {
  const b = useBranding();
  const name = b.brand_name || "Notre Oui";
  const logo = dark ? (b.logo_dark_url || b.logo_url) : b.logo_url;
  const [ok, setOk] = useState(true);
  useEffect(() => { setOk(true); }, [logo]);

  if (logo && ok) {
    return (
      <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-mark">
        <img src={logo} alt={name} onError={() => setOk(false)}
          className={variant === "compact" ? "h-8 w-auto max-w-[140px] object-contain" : "h-9 w-auto max-w-[180px] object-contain"} />
      </div>
    );
  }
  const [first, ...rest] = name.split(" ");
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-mark">
      <div className="w-9 h-9 rounded-xl bg-stone-900 flex items-center justify-center shrink-0">
        <span className="text-champagne font-serif text-lg leading-none">{(name.replace(/[^A-Za-z]/g, "")[0] || "A").toUpperCase()}</span>
      </div>
      {variant === "full" && (
        <div className="leading-tight">
          <div className="font-serif text-[15px] text-stone-900">{first || name}</div>
          {rest.length > 0 && <div className="text-[10px] uppercase tracking-[0.2em] text-stone-400">{rest.join(" ")}</div>}
        </div>
      )}
    </div>
  );
}
